/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetFileFormat } from './assetFileFormat';


export interface AssetAspectRatio { 
    id: object;
    /**
     * aspect ratio key
     */
    aspectRatio: string;
    /**
     * A human readable aspect ratio value, if asset has any
     */
    aspectRatioName?: string;
    /**
     * The current, default file format
     */
    defaultFileFormat: string;
    formats?: Array<AssetFileFormat>;
}

